// Getters
export const USG_IS_ERROR = 'usage/stateUsgIsError';
export const USG_IS_LOADING = 'usage/stateUsgIsLoading';
export const USG_GET_DATA = 'usage/stateUsgData';
export const USG_GET_FILTER = 'usage/stateUsgFilter';
export const USG_GET_MANY_RECORDS_ALERT = 'usage/stateUsgGetManyRecordsAlert';

// Actions
// export const USG_ACTION_DATA = 'usage/stateUsgData';
export const USG_ACTION_FILTER = 'usage/stateUsgActionSearchByFilter';
export const USG_TWA_ACTION_FILTER = 'usage/stateUsgTwaActionSearchByFilter';
export const USG_ACTION_TABLE_REF = 'usage/stateUsgActionTableRef';
export const USG_ACTION_MANY_RECORDS_ALERT = 'usage/stateUsgActionTooManyRecordsAlert';



// WEBPACK FOOTER //
// ./src/store/types_usage.js